Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.IntactSKUs = Greenmile.RouteSummary.IntactSKUs || {};
Greenmile.RouteSummary.IntactSKUs.Grid = Greenmile.RouteSummary.IntactSKUs.Grid || {};

Greenmile.RouteSummary.IntactSKUs.Grid = (function () {

  function Grid () {

      Greenmile.RouteSummary.SKUs.Grid.apply(this, arguments);

      this.entity = 'RouteSummaryIntactStock';

      this.containerGrid = "#RouteSummary #routeStockSummary #grid_intact";
      this.gridActionsSelector = "#RouteSummary #routeStockSummary .gridActions_intact";
      this.entityToActionGrid = 'RouteSummaryIntactStock';
      this.countCustomColumns = 0;
  }

  return Grid;

}());